import React from 'react';
import { connect } from 'react-redux';
import { setHologramPosition } from 'components/collage/CollageSlice.js';

// CSS
import './HologramMenu.css';

class HologramMenu extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {

    let className = 'HologramMenu';
    let style = {
      left: this.props.collage.hologramPosition.x,
      top: this.props.collage.hologramPosition.y
    }

    return (
      <div className={className} style={style}>
        {this.props.options.map((option, index) => {
          let className = 'ButtonReset HologramOption HologramOption--' + index;
          return (
            <button 
              key={('holo'+index)}
              className={className} 
              onClick={(event) => {
                option.onClick();
                this.props.setHologramPosition(null);
              }}
            >
              <div className="HologramIcon"><img src={option.icon} /></div>
              <span className="HologramText">{option.name}</span>
            </button>
          )
        })}
      </div>
    );

  }
}
const mapStateToProps = state => ({
  collage: state.collage
});

export default connect(
  mapStateToProps,
  {setHologramPosition}
)(HologramMenu)
